import React, { useEffect, useState } from "react";
import { Carousel } from "react-bootstrap";
import "./ProductdetailPage.css";
import verify_security from "./../../../assets/verify_security.png";
import return_policy from "./../../../assets/return_policy.png";
import { connect } from "react-redux";
import { Rating } from "react-simple-star-rating";
import product_default from "../../../assets/product_default.png";
import { useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { maintainCartdata } from "../../home/redux/actions";
import LoaderPage from "../../loader/components/LoaderPage";
import RattingPage from "./RattingPage";
import { useTranslation } from "react-i18next";
import { fetchHeaderContent } from "../../seoroute/redux/actions";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { MINUS, PLUS_ADD } from "../../comman/components/CommonimagePath";
import { getRequestcall } from "../../comman/util/getRequest";
import {
  ADD_PRODUCT_CART,
  CART_ITEM_DELETE,
  PRODUCT_DETAIL,
  PRODUCT_LIST,
} from "../../constants/apiurl";
import { postRequestcall } from "../../comman/util/postRequest";
const ProductCommonPage = React.lazy(() =>
  import("../../comman/components/ProductCommonPage")
);
const CardchangePage = React.lazy(() =>
  import("../../modal/components/CardchangePage")
);

function ProductdetailPage(props) {

  let getpid = window.location.pathname.split("/").pop();
  const { t } = useTranslation();
  const location = useLocation();
  const [productDetail, setProductdetail] = useState({
    store_id: "",
    pid: "",
    vatrate: "",
    title: "",
    title_in_tr: "",
    description: "",
    description_in_tr: "",
    images: [],
    price: "",
    rating_ratio: "",
    discount: "",
    current_vid: "",
    cart_detail: {},
    variations: [],
    out_of_stock: false,
  });
  // Cart clear
  const [cartclear, setCartclear] = useState(false);
  const [cartInformation, setCartinformation] = useState({
    cart_store_name: "",
    current_store_name: "",
    store_id: "",
  });
  const [relatedlist, setRelatedlist] = useState([]);
  const [loader, setLoader] = useState(false);
  const navigate = useNavigate();
  const [productId, setProductid] = useState("");
  const [callingadd, setCallingadd] = useState("");
  

  // eslint-disable-next-line
  useEffect(() => {
    (async () => getProductdetail())();
    // eslint-disable-next-line
  }, [location?.state?.refresh]);

  // eslint-disable-next-line
   useEffect(() => {
    changeProducttitle();
     // eslint-disable-next-line
   }, [props?.language]);

 const changeProducttitle = () => { 
  if(props?.language === "Tr") {
    props?.fetchHeaderContent(productDetail?.title_in_tr, "", "");
  }else{
    props?.fetchHeaderContent(productDetail?.title, "", "");
  }
 }

  const getProductdetail = async () => {
    let url = PRODUCT_DETAIL + `/v2/${getpid}`;
    let productdetail = await getRequestcall(url, props.access_token);
    if (productdetail?.status === 200) {
      let productData = await productdetail.json();
      props?.fetchHeaderContent(productData?.data?.title, "", "");
      if (!props.access_token) {
        productData?.data?.variations.forEach((variation) => {
          let getProduct = props?.cartdata?.filter(
            (item) => item?.variation_id === variation.vid
          );
          if (getProduct?.length > 0) {
            if (variation.vid === getProduct[0]?.variation_id) {
              variation.cart_detail = getProduct[0]?.cart_detail; // update variation cart_detail
            }
          }
        });
      }
      setProductdetail({
        store_id: productData?.data?.store_id,
        vatrate: productData?.data?.vatrate,
        pid: productData?.data?.pid,
        title: productData?.data?.title,
        title_in_tr: productData?.data?.title_in_tr,
        description: productData?.data?.description,
        description_in_tr: productData?.data?.description_in_tr,
        images: productData?.data?.images,
        variations: productData?.data?.variations,
        rating_ratio: productData?.data?.rating_ratio,
        out_of_stock: productData?.data?.variations[0]?.out_of_stock,
        price: productData?.data?.variations[0]?.price,
        discount: productData?.data?.variations[0]?.discount,
        current_vid: productData?.data?.variations[0]?.vid,
        cart_detail: productData?.data?.variations[0]?.cart_detail,
      });
      callCardDetail(productData);
    }
  };

  const callCardDetail = async (productData) => {
    if (props.access_token) {
      setCartinformation({
        cart_store_name: productData?.data?.cart_detail?.store_name,
        current_store_name: productData?.data?.store_name,
        store_id:
          productData?.data?.cart_detail?.store_id === null
            ? ""
            : productData?.data?.cart_detail?.store_id,
      });
    } else {
      if (props?.cartdata?.length === 0) {
        setCartinformation({
          cart_store_name: "",
          current_store_name: "",
          store_id: "",
        });
      } else {
        setCartinformation({
          cart_store_name: props?.cartdata[0]?.store_name, // take it from props.cartdata redux
          current_store_name: productData?.data?.store_name,
          store_id: props?.cartdata[0]?.store_id,
        });
      }
    }
    ralatedProductlist(productData?.data?.store_id);
  };

  // Add to cart
  const addtoCart = async (pid) => {
    if (
      cartInformation?.store_id !== productDetail.store_id &&
      cartInformation?.store_id !== ""
    ) {
      setCallingadd("detail");
      setProductid(pid);
      setCartclear(true);
    } else {
      addProducttocart(pid);
    }
  };

  const addProducttocart = async (pid) => {
    let quantity = 1;
    if (props.access_token) {
      let geturl =
        ADD_PRODUCT_CART +
        `?store_id=${productDetail.store_id}&product_id=${pid}&variation_id=${
          productDetail.current_vid
        }&quantity=${quantity}&id=${""}`;
      let getCartapiresponse = await postRequestcall(
        geturl,
        props?.access_token,
        ""
      );
      if (getCartapiresponse?.status === 200) {
        let getId = await getCartapiresponse.json();
        getId = getId?.data;
        storeCartProducts(productDetail, getId, quantity);
      }
    } else {
      storeCartProducts(productDetail, "", quantity);
    }
  };

  const quantityPlus = async (get_cart_detail) => {
    let check_stock = true;
    let updated_id;
    let quantity = get_cart_detail?.quantity;
    let getVariation = productDetail.variations.filter(
      (item) => item.vid === productDetail.current_vid
    );
    if (getVariation[0].is_stock === "yes") {
      if (quantity + 1 > getVariation[0].stock) {
        check_stock = false;
        toast.error(
          t("pages.You can not add more than") +
            " " +
            getVariation[0]?.stock +
            " " +
            t("pages.quantities of this product")
        );
      }
    } else {
      check_stock = true;
    }
    if (check_stock === true) {
      if (props.access_token) {
        if (getVariation.length > 0) {
          let geturl =
            ADD_PRODUCT_CART +
            `?store_id=${productDetail.store_id}&product_id=${
              productDetail.pid
            }&variation_id=${productDetail.current_vid}&quantity=${
              quantity + 1
            }&id=${get_cart_detail?.id}`;
          let getResponse = await postRequestcall(
            geturl,
            props?.access_token,
            ""
          );
          if (getResponse?.status === 200) {
            let id = await getResponse.json();
            updated_id = id.data;
            storeCartProducts(productDetail, updated_id, quantity + 1);
          }
        }
      } else {
        storeCartProducts(productDetail, "", quantity + 1);
      }
    }
  };

  const quantityMinus = async (get_cart_detail) => {
    let updated_id;
    let getResponse;
    if (props.access_token) {
      if (get_cart_detail?.quantity === 1) {
        let geturl = CART_ITEM_DELETE + `?id=${get_cart_detail?.id}`;
        getResponse = await postRequestcall(geturl, props?.access_token, "");
      } else {
        let geturl =
          ADD_PRODUCT_CART +
          `?store_id=${productDetail.store_id}&product_id=${
            productDetail.pid
          }&variation_id=${productDetail.current_vid}&quantity=${
            get_cart_detail?.quantity - 1
          }&id=${get_cart_detail?.id}`;
        getResponse = await postRequestcall(geturl, props?.access_token, "");
      }
      if (getResponse?.status === 200) {
        if (get_cart_detail?.quantity === 1) {
          storeCartProducts(productDetail, "", null);
        } else {
          let id = await getResponse.json();
          updated_id = id?.data;
          storeCartProducts(
            productDetail,
            updated_id,
            get_cart_detail?.quantity - 1
          );
        }
      }
    } else {
      if (get_cart_detail?.quantity === 1) {
        storeCartProducts(productDetail, "", null);
      } else {
        storeCartProducts(productDetail, "", get_cart_detail?.quantity - 1);
      }
    }
  };

  const storeCartProducts = (getproductDetail, id, quantity) => {
    let cart_detail = {};
    getproductDetail.variations.forEach((item) => {
      if (item.vid === getproductDetail.current_vid) {
        cart_detail = quantity === null ? null : { id: id, quantity: quantity };
        item.cart_detail = cart_detail;
      }
    });
    let getValue = getproductDetail.variations.filter(
      (item) => item.vid === getproductDetail.current_vid
    ); // After filter getting the current variation
    setProductdetail({
      ...productDetail,
      variations: getproductDetail.variations,
      price: getValue[0].price,
      discount: getValue[0].discount,
      current_vid: getValue[0].vid,
      cart_detail: getValue[0].cart_detail,
    });
    filterCurrentorder(getproductDetail, getValue[0]);
  };

  // Filter current order list update and add

  const filterCurrentorder = (productDetail, variation) => {
    let flag = true;
    let getProduct = props?.cartdata?.filter(
      (item) => item.variation_id === variation.vid
    );
    let productObj = {
      cart_detail: variation?.cart_detail,
      id: variation?.cart_detail?.id,
      store_id: productDetail?.store_id,
      product_id: productDetail?.pid,
      variation_id: variation?.vid,
      quantity: variation?.cart_detail?.quantity,
      title_in_tr: productDetail?.title_in_tr,
      product_name: productDetail?.title,
      product_deleted_at: null,
      images: productDetail?.images[0],
      img_url: productDetail?.images[0],
      is_stock: variation?.is_stock,
      stock: variation?.stock,
      price: variation?.price,
      discount: variation?.discount,
      product_qty: variation?.quantity,
      unit_name: variation?.unit,
      unit_id: variation?.unit_id,
      variation_deleted_at: null,
      out_of_stock: variation?.out_of_stock,
      total_rating: productDetail?.total_rating,
      vatrate: productDetail?.vatrate,
    };
    if (getProduct?.length !== 0) {
      props?.cartdata?.forEach((item, index) => {
        if (item.variation_id === variation.vid) {
          if (variation?.cart_detail === null) {
            flag = false;
          } else {
            props.cartdata[index] = productObj; // update
          }
        }
      });
    } else {
      if (variation?.cart_detail === null) {
        flag = false;
      } else {
        props?.cartdata.push(productObj); // add
      }
    }
    if (flag === false) {
      let getCart = props?.cartdata?.filter(
        (item) => item.variation_id !== variation.vid
      );
      getCartlist(getCart, true);
    } else {
      getCartlist(props.cartdata, true);
    }
  };

  const selectVariation = (e, vid) => {
    e.preventDefault();
    let getValue = productDetail.variations.filter((item) => item.vid === vid);
    setProductdetail({
      ...productDetail,
      variations: productDetail?.variations,
      out_of_stock: getValue[0]?.out_of_stock,
      price: getValue[0]?.price,
      discount: getValue[0]?.discount,
      current_vid: getValue[0]?.vid,
      cart_detail: getValue[0]?.cart_detail,
    });
  };

  const ralatedProductlist = async (storeId) => {
    setLoader(true);
    let url = PRODUCT_LIST +`/v2?store_id=${storeId}&page=${1}&service_id=${location?.state?.categoryId}&for_users=yes`;
    let getProductlist = await getRequestcall(url, props?.access_token);
    if (getProductlist?.status === 200) {
      let list = await getProductlist.json();
      if (list?.data?.productList?.data?.length === 0) {
      } else {
        let productList = [];
        let product = {};
        list?.data?.productList?.data?.forEach((item) => {
          let getVariation = item?.variations.map((item) => {
            return {
              label: `${item?.quantity} ${item?.unit}`,
              value: item?.unit,
              label_tr: `${item?.quantity} ${item?.unit_in_tr}`,
            };
          });
          product = {
            description: item?.description,
            images: item?.images,
            img_url: item?.img_url,
            pid: item?.pid,
            service_id: item?.service_id,
            service_name: item?.service_name,
            title_in_tr: item?.title_in_tr,
            title: item?.title,
            variations: item?.variations,
            price: item?.variations[0]?.price,
            discount: item?.variations[0]?.discount,
            current_vid: item?.variations[0]?.vid,
            cart_detail: item?.variations[0]?.cart_detail,
            out_of_stock: item?.variations[0]?.out_of_stock,
            total_rating: item?.total_rating,
            rating_ratio: item?.rating_ratio,
            store_id: storeId,
            store_name: list?.data?.store?.title,
            vatrate: item?.vatrate,
            getVariation: getVariation,
          };
          if (!props.access_token) {
            let getProduct = props?.cartdata?.filter(
              (item) => item?.variation_id === product?.current_vid
            );
            if (getProduct?.length > 0) {
              product?.variations.forEach((item, index) => {
                if (item.vid === getProduct[0]?.variation_id) {
                  product.variations[index].cart_detail =
                    getProduct[0]?.cart_detail; // update variation cart_detail
                  product.cart_detail = getProduct[0]?.cart_detail; // update product cart detail
                }
              });
            }
          }
          productList.push(product);
        });
        // Filter the current product
        productList = productList.filter((item) => item.pid !== getpid);
        setRelatedlist(productList);
      }
    }
    setLoader(false);
  };

  const navigateToproductdetail = (e, pid) => {
    var timestamp = new Date().getTime();
    navigate(`/product-detail/${pid}`, {
      state: {
        categoryId: location?.state?.categoryId,
        productlist: location?.state?.productlist,
        refresh: timestamp,
      },
    });
  };

  // Add to cart for related product list
  const addtoCartfromProductlist = async (e, pid) => {
    e.stopPropagation();
    if (
      cartInformation?.store_id !== productDetail.store_id &&
      cartInformation?.store_id !== ""
    ) {
      setCallingadd("list");
      setProductid(pid);
      setCartclear(true);
    } else {
      addProductfromlist(pid);
    }
  };

  const addProductfromlist = async (pid) => {
    let id = "";
    let quantity = 1;
    let getProduct = relatedlist.filter((item) => item.pid === pid);
    if (getProduct.length > 0) {
      if (props.access_token) {
        let geturl =
          ADD_PRODUCT_CART +
          `?store_id=${productDetail.store_id}&product_id=${pid}&variation_id=${getProduct[0].current_vid}&quantity=${quantity}&id=${id}`;
        let getCartapiresponse = await postRequestcall(
          geturl,
          props?.access_token,
          ""
        );
        if (getCartapiresponse?.status === 200) {
          let getId = await getCartapiresponse.json();
          getId = getId?.data;
          storeotherCartProducts(relatedlist, getId, getProduct, quantity);
        }
      } else {
        storeotherCartProducts(relatedlist, "", getProduct, quantity);
      }
    }
  };

  const productPlus = async (e, pid, get_cart_detail) => {
    e.stopPropagation();
    let check_stock = true;
    let getid = get_cart_detail?.id;
    let updated_id;
    let quantity = get_cart_detail?.quantity;
    let getProduct = relatedlist.filter((item) => item.pid === pid);
    if (getProduct?.length > 0) {
      let getVariation = getProduct[0].variations.filter(
        (item) => item.vid === getProduct[0].current_vid
      );
      if (getVariation?.length !== 0) {
        if (getVariation[0].is_stock === "yes") {
          if (quantity + 1 > getVariation[0].stock) {
            check_stock = false;
            toast.error(t('pages.Out of Stock'))
            // toast.error(
            //   t("pages.You can not add more than") +
            //     " " +
            //     getVariation[0]?.stock +
            //     " " +
            //     t("pages.quantities of this product")
            // );
          }
        } else {
          check_stock = true;
        }
        if (check_stock === true) {
          if (props.access_token) {
            let geturl =
              ADD_PRODUCT_CART +
              `?store_id=${
                productDetail.store_id
              }&product_id=${pid}&variation_id=${
                getProduct[0].current_vid
              }&quantity=${quantity + 1}&id=${getid}`;
            let getResponse = await postRequestcall(
              geturl,
              props?.access_token,
              ""
            );
            if (getResponse?.status === 200) {
              let id = await getResponse.json();
              updated_id = id.data;
              storeotherCartProducts(
                relatedlist,
                updated_id,
                getProduct,
                quantity + 1
              );
            }
          } else {
            storeotherCartProducts(relatedlist, "", getProduct, quantity + 1);
          }
        }
      }
    }
  };

  const productMinus = async (e, pid, get_cart_detail) => {
    e.stopPropagation();
    let getid = get_cart_detail?.id;
    let updated_id;
    let quantity = get_cart_detail?.quantity;
    let getResponse;
    let getProduct = relatedlist.filter((item) => item.pid === pid);
    if (getProduct.length > 0) {
      if (props.access_token) {
        if (get_cart_detail?.quantity === 1) {
          let geturl = CART_ITEM_DELETE + `?id=${getid}`;
          getResponse = await postRequestcall(geturl, props?.access_token, "");
        } else {
          let geturl =
            ADD_PRODUCT_CART +
            `?store_id=${
              productDetail.store_id
            }&product_id=${pid}&variation_id=${
              getProduct[0].current_vid
            }&quantity=${quantity - 1}&id=${getid}`;
          getResponse = await postRequestcall(geturl, props?.access_token, "");
        }
        if (getResponse?.status === 200) {
          if (get_cart_detail?.quantity === 1) {
            storeotherCartProducts(relatedlist, "", getProduct, null);
          } else {
            let id = await getResponse.json();
            updated_id = id?.data;
            storeotherCartProducts(
              relatedlist,
              updated_id,
              getProduct,
              quantity - 1
            );
          }
        }
      } else {
        if (get_cart_detail?.quantity === 1) {
          storeotherCartProducts(relatedlist, "", getProduct, null);
        } else {
          storeotherCartProducts(relatedlist, "", getProduct, quantity - 1);
        }
      }
    }
  };

  const storeotherCartProducts = (relatedlist, id, getProduct, quantity) => {
    // For Before and after login maintain cart products
    let productList = [];
    let cart_detail = {};
    let currentProduct = {};
    relatedlist.forEach((item, index) => {
      if (item.pid === getProduct[0]?.pid) {
        item.variations.forEach((item) => {
          // cart_detail id and quantity updated
          if (item.vid === getProduct[0].current_vid) {
            cart_detail =
              quantity === null ? null : { id: id, quantity: quantity };
            item.cart_detail = cart_detail;
          }
        });
        let getValue = item.variations.filter(
          (item) => item.vid === getProduct[0].current_vid
        );
        relatedlist[index].cart_detail = getValue[0]?.cart_detail;
        productList.push(relatedlist[index]);
        currentProduct = relatedlist[index];
      } else {
        productList.push(relatedlist[index]);
      }
    });
    setRelatedlist(productList);
    filterOtherproduct(currentProduct);
  };

  // Filter current order list update and add

  const filterOtherproduct = (product) => {
    let flag = true;
    let getProduct = props.cartdata.filter(
      (item) => item.variation_id === product?.variations[0]?.vid
    );
    let productObj = {
      cart_detail: product?.variations[0]?.cart_detail,
      id: product?.variations[0]?.cart_detail?.id,
      store_id: product?.store_id,
      product_id: product?.pid,
      variation_id: product?.variations[0]?.vid,
      quantity: product?.variations[0]?.cart_detail?.quantity,
      product_name: product?.title,
      product_deleted_at: null,
      images: product?.images,
      img_url: product?.img_url,
      is_stock: product?.variations[0]?.is_stock,
      stock: product?.variations[0]?.stock,
      price: product?.variations[0]?.price,
      discount: product?.variations[0]?.discount,
      product_qty: product?.variations[0]?.quantity,
      unit_name: product?.variations[0]?.unit,
      unit_id: product?.variations[0]?.unit_id,
      variation_deleted_at: null,
      out_of_stock: product?.variations[0]?.out_of_stock,
      total_rating: product?.total_rating,
      vatrate: product?.vatrate,
    };
    if (getProduct.length !== 0) {
      props.cartdata.forEach((item, index) => {
        if (item.variation_id === product?.variations[0]?.vid) {
          if (product?.variations[0]?.cart_detail === null) {
            flag = false;
          } else {
            props.cartdata[index] = productObj; // update
          }
        }
      });
    } else {
      if (product?.variations[0]?.cart_detail === null) {
        flag = false;
      } else {
        props.cartdata.push(productObj); // add
      }
    }
    if (flag === false) {
      let getCart = props.cartdata.filter(
        (item) => item.variation_id !== product?.variations[0]?.vid
      );
      getCartlist(getCart, true);
    } else {
      getCartlist(props.cartdata, true);
    }
  };

  const getCartlist = (cartdata, totalAmtchange) => {
    let total_amount = 0;
    let final_vat_rate = 0;
    let final_sub_total = 0;
    if (cartdata.length !== 0) {
      cartdata.forEach((product) => {
        let productPrice = 0;
        let vat_rate = 0;
        let sub_total = 0;
        if (
          product?.discount !== null &&
          product?.discount !== 0 &&
          product?.discount < product?.price
        ) {
          productPrice = product?.discount * product?.quantity;
        } else {
          productPrice = product?.price * product?.quantity;
        }
        if (
          typeof product.vatrate === "undefined" ||
          product.vatrate === null
        ) {
          sub_total = productPrice;
        } else {
          sub_total = productPrice / (product.vatrate / 100 + 1);
          vat_rate = productPrice - sub_total;
          final_vat_rate = final_vat_rate + vat_rate;
        }
        final_sub_total = final_sub_total + sub_total;
        total_amount = total_amount + productPrice;
      });
      // Developer comment :: If user apply coupon or delivery charges and after that if user add product or minus product then the discount and charges will be zero
      let amount = {
        ...props.amount,
        sub_total: final_sub_total.toFixed(2),
        vat_rate: final_vat_rate.toFixed(2),
        total_amount: total_amount,
        discount: totalAmtchange === true ? 0 : props?.amount?.discount,
        charges: totalAmtchange === true ? 0 : props?.amount?.charges,
        coupon_code: totalAmtchange === true ? "" : props?.amount?.coupon_code,
        offer_id: totalAmtchange === true ? "" : props?.amount?.offer_id,
      };
      props.maintainCartdata(cartdata, amount); // maintain in redux
    } else {
      props.maintainCartdata([], {}); // clear the redux cart
    }
  };


  const callAddtocart = (className) => {
       return (
        <div className={className}>
        {props.type === "vendor" ? (
          productDetail.store_id === props?.storeDetail?.store_id ? (
            <></>
          ) : productDetail?.out_of_stock === true ? (
            <h5
              style={{
                fontSize: "15px",
                color: "#FF0000",
                marginBottom: "15px",
              }}
            >
              {t("pages.Out of Stock")}
            </h5>
          ) : productDetail?.cart_detail ? (
            <div className="me-4 d-flex -center">
              <button
                className={"card-minus "}
                onClick={() =>
                  quantityMinus(productDetail?.cart_detail)
                }
              >
                <img src={MINUS} height="18" width="18" alt="minus" />
              </button>
              <input
                value={productDetail?.cart_detail?.quantity}
                className={"card-qty"}
                readOnly={true}
              />
              <button
                className={"card-plus "}
                onClick={() =>
                  quantityPlus(productDetail?.cart_detail)
                }
              >
                <img src={PLUS_ADD} height="18" width="18" alt="plus" />
              </button>
            </div>
          ) : (
            <div>
              <button
                className={"Add-to-Card fa-green "}
                onClick={() => addtoCart(productDetail?.pid)}
              >
                {t("pages.Add to Card")}
              </button>
            </div>
          )
        ) : productDetail?.out_of_stock === true ? (
          <h5
            style={{
              fontSize: "15px",
              color: "#FF0000",
              marginBottom: "15px",
            }}
          >
            {t("pages.Out of Stock")}
          </h5>
        ) : productDetail?.cart_detail ? (
          <div className="mb-4 me-4 d-flex align-center">
            <button
              className={"card-minus "}
              onClick={() =>
                quantityMinus(productDetail?.cart_detail)
              }
            >
              <img src={MINUS} height="18" width="18" alt="minus" />
            </button>
            <input
              value={productDetail?.cart_detail?.quantity}
              readOnly={true}
              className={"card-qty"}
            />
            <button
              className={"card-plus "}
              onClick={() => quantityPlus(productDetail?.cart_detail)}
            >
              <img src={PLUS_ADD} height="18" width="18" alt="plus" />
            </button>
          </div>
        ) : (
          <div className="mb-4 add-cart-mob">
            <button
              className={"Add-to-Card fa-green "}
              onClick={() => addtoCart(productDetail?.pid)}
            >
              {t("pages.Add to Card")}
            </button>
          </div>
        )}
      </div>
       )
  }

  if (loader) return <LoaderPage className={"user-dashboard"} />;

  return (
    <div className="product-details">
      <div className="pt-7rem mb-3">
        <div className="container-xl">
          <div className="col-xl-12">
            <div className="row">
              <div className="col-lg-4 image_side">
                <Carousel
                  variant="dark"
                  pause={true}
                  className={"product_carousel"}
                  controls={false}
                  interval={null}
                >
                  {productDetail.images.map((item, index) => (
                    <Carousel.Item key={index?.toString()} className="product-img">
                      <LazyLoadImage
                        className="item_pic"
                        src={item}
                        alt="First slide"
                        onError={(event) => {
                          event.target.src = product_default;
                        }}
                      ></LazyLoadImage>
                    </Carousel.Item>
                  ))}
                </Carousel>
              </div>
              <div className="col-lg-8 detail_side pt-3 pb-3">
                <div className="home-delivery-text">
                    <h5 className="title">
                       {t("pages.Home Delivery Available")}
                    </h5>
                 </div>
                <h5 className="product-title text-20 w500">
                  {props.language === "Tr"
                    ? productDetail?.title_in_tr
                    : productDetail?.title}
                </h5>
                <div className="rating text-20 mb-2">
                  <Rating
                    initialValue={Number(productDetail?.rating_ratio)}
                    size={window.width > 600 ? 19 : 16}
                    fillColor={"var(--pr-color)"}
                    allowHalfIcon
                    readonly={true}
                  />
                  <label className="text-12 w400" hidden>
                    123 {t("pages.storedetail.products.reviews")}
                  </label>
                </div>
                <div className="variations">
                  <div className="price-box">
                  <h5 className="text-20 w500 m-right-5">
                    {productDetail?.discount !== null &&
                    productDetail?.discount !== 0 &&
                    productDetail?.discount < productDetail?.price ? (
                      <>
                        <del style={{ color: "#8c8d9f" }}>
                          {productDetail?.price}{" "}
                          {process.env.REACT_APP_CURRENCY_SYMBOL}
                        </del>{" "}
                        <span className="product_price">
                          {productDetail?.discount}{" "}
                          {process.env.REACT_APP_CURRENCY_SYMBOL}
                        </span>
                      </>
                    ) : (
                      <span className="product_price">
                        {productDetail?.price}{" "}
                        {process.env.REACT_APP_CURRENCY_SYMBOL}
                      </span>
                    )}
                  </h5>
                  {callAddtocart("cart d-flex mob-detail-cart")}
                  </div>
                  <div className="variation_list_product">
                    {productDetail?.variations.map((item, index) => (
                      <button
                        key={index?.toString()}
                        className={
                          item.vid === productDetail?.current_vid
                            ? "btn-white active"
                            : "btn-white"
                        }
                        onClick={(e) => selectVariation(e, item.vid)}
                      >
                        {item?.quantity +
                          " " +
                          (props.language === "Tr"
                            ? item?.unit_in_tr
                            : item?.unit)}
                      </button>
                    ))}
                  </div>
                </div>

                <p className="description mb-4">
                  {props.language === "Tr"
                    ? productDetail?.description_in_tr
                    : productDetail?.description}
                </p>
                {/* for desktop */}
              
                {callAddtocart("cart d-flex btn-cart-pdetail mb-4")}
                
                <div className=" captions">
                  <div className="col-5">
                    <div className="card border-0">
                      <div className="card-body">
                        <LazyLoadImage
                          alt=""
                          src={verify_security}
                          className={"me-2"}
                        />
                        <div>
                          <h5 className="text-14 mb-1">
                            {t("pages.storedetail.products.box-1-title")}
                          </h5>
                          <p className="text-12 mb-0">
                            {t("pages.storedetail.products.box-1-description")}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-5">
                    <div className="card border-0">
                      <div className="card-body">
                        <LazyLoadImage
                          alt=""
                          src={return_policy}
                          className={"me-2"}
                        />
                        <div>
                          <h5 className="text-14 mb-1">
                            {t("pages.storedetail.products.box-2-title")}
                          </h5>
                          <p className="text-12 mb-0">
                            {t("pages.storedetail.products.box-2-description")}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-12 product_reviews pt-3">
                  <RattingPage productDetail={productDetail} />
                </div>
              </div>
             
              <div className="col-xl-12 related-product">
                <h5 className="product-title mb-2 ">
                  {t("pages.storedetail.products.other_products")}
                </h5>
                <ProductCommonPage
                  navigateToproductdetail={navigateToproductdetail}
                  language={props?.language}
                  store_id={productDetail?.store_id}
                  quantityMinus={productMinus}
                  quantityPlus={productPlus}
                  addtoCart={addtoCartfromProductlist}
                  data={relatedlist}
                  setProductlist={setRelatedlist}
                  search={""}
                  className={"Comman_product"} //Comman_product
                  innerClass={"innerProduct"}
                  listClass={"col-sm-12 col-md-12 col-lg-6 col-xl-4"}
                  is_productlist={false}
                  cartInformation={cartInformation}
                  setCartinformation={setCartinformation}
                  {...props}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      {cartclear && (
        <CardchangePage
          cartclear={cartclear}
          cartInformation={cartInformation}
          setCartinformation={setCartinformation}
          setCartclear={setCartclear}
          addProducttocart={
            callingadd === "detail" ? addProducttocart : addProductfromlist
          }
          productId={productId}
        />
      )}
    </div>
  );
}

const mapStateToProps = (state) => ({
  access_token: state?.login.access_token,
  type: state?.login?.type,
  storeDetail: state?.dashboard?.storeDetail,
  cartdata: state?.home?.cartdata,
  language: state?.languageState?.language,
});

export default connect(mapStateToProps, {
  maintainCartdata,
  fetchHeaderContent,
})(ProductdetailPage);
